$('.note-editable a').each(function () {
  if ($(this).text().startsWith('bouton:')) {
    $(this).text($(this).text().replace('bouton:', ''));
    return $(this).addClass('button');
  }
});
